import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-scroll';
import { FaArrowDown } from 'react-icons/fa';
import ParticleLogo3D from './ParticleLogo3D';

const Header = () => {
  const headerRef = useRef(null);

  // Cinematic scroll-parallax: fades away as the visitor scrolls past.
  const { scrollYProgress } = useScroll({
    target: headerRef,
    offset: ['start start', 'end start'],
  });
  const sceneOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  const indicatorOpacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);

  return (
    <header ref={headerRef} id="header" className="relative h-screen w-full overflow-hidden bg-[#061a10]">
      {/* Real Three.js particle logo with bloom - the only visual on this screen */}
      <motion.div style={{ opacity: sceneOpacity }} className="absolute inset-0">
        <ParticleLogo3D />
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        style={{ opacity: indicatorOpacity }}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center gap-2"
      >
        <span className="text-cream/50 text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <Link
          to="about"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="cursor-pointer"
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="text-accent-green text-2xl hover:text-cream transition-colors"
          >
            <FaArrowDown />
          </motion.div>
        </Link>
      </motion.div>
    </header>
  );
};

export default Header;
